import { RtsPackagesResponseWrap } from "../../models/responseModels/rtsPackageResponse";
import { ClientUIResponse, RtsUIResponse } from "../../models/ApiResponse";
import { RtsDataArgs } from "../../../pages/dedicatedDelivery/DdTypes";
import agent from "../../api/agent";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AddRtsRequest, EditRtsRequest } from "../../models/requestModels/RtsRequestAdminPanel";
import { RtsEventTypesResponse } from "../../models/responseModels/rtsEventTypesResponse";
import { Client } from "../../models/responseModels/clientsResponse";

type InitialState = {
    isRtsLoading: boolean;
    rtsData: RtsPackagesResponseWrap;
    rtsEventTypes : RtsEventTypesResponse[];
    errorMessage: string | null;
    fdpAssociatedClients: Client[];
};

const initialState: InitialState = {
    isRtsLoading: false,
    rtsData: { totalRows: 0, packages: [] },
    rtsEventTypes : [], 
    fdpAssociatedClients: [],
    errorMessage: null,
};

export const getRtsPackages = createAsyncThunk<
    RtsUIResponse,
    RtsDataArgs
>(
    "dedicated-delivery/rts-response",
    async (rtsDataArgs: RtsDataArgs) => {
        const response = await agent.DedicatedDeliveryAgent.getRtsPackageData(
            rtsDataArgs
        );
        return response;
    }
);

export const persistNewRts = createAsyncThunk<any, AddRtsRequest>(
  "dedicated-delivery/persist-new-rts-response",
  async (rtsDataArgs: AddRtsRequest) => {
    const response = await agent.DedicatedDeliveryAgent.persistNewRtsData(
      rtsDataArgs
    );
    return response;
  }
);

export const editRts = createAsyncThunk<any, EditRtsRequest>(
  "dedicated-delivery/edit-rts-response",
  async (rtsDataArgs: EditRtsRequest) => {
    const response = await agent.DedicatedDeliveryAgent.editRtsData(
      rtsDataArgs
    );
    return response;
  }
);

export const getEventTypes = createAsyncThunk<
    any, number>(
    "dedicated-delivery/rts-event-types-response",
    async (clientId : number) => {
        const response = await agent.DedicatedDeliveryAgent.getRtsEventTypes(
   clientId
        );
        return response;
    }
);


export const getFdpClients = createAsyncThunk<ClientUIResponse, number>(
  "dedicated-delivery/fdp-clients",
  async (fdpId: number) => {
    const response = await agent.DedicatedDeliveryAgent.getFdpAssociatedClients(
      fdpId
    );
    return response;
  }
);

 const dedicatedDeliveryRtsSlice = createSlice({
    name: "dedicatedDeliveryRts",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getRtsPackages.pending, (state) => {
          state.isRtsLoading = true;
        })
        .addCase(getRtsPackages.fulfilled, (state, action) => {
          state.isRtsLoading = false;
          if (action.payload.isSuccess) {
            state.rtsData = action.payload.data;
          } else {
            state.rtsData.packages = [];
          }
        })
        .addCase(getRtsPackages.rejected, (state, action) => {
          state.isRtsLoading = false;
          state.rtsData.packages = [];
          state.errorMessage = action.error.message!;
        })
        .addCase(getEventTypes.pending, (state) => {
          state.isRtsLoading = true;
        })
        .addCase(getEventTypes.fulfilled, (state, action) => {
          state.isRtsLoading = false;
          if (action.payload.isSuccess) {
            state.rtsEventTypes = action.payload.data;
          } else {
            state.rtsEventTypes = [];
          }
        })
        .addCase(getEventTypes.rejected, (state, action) => {
          state.isRtsLoading = false;
          state.rtsEventTypes = [];
          state.errorMessage = action.error.message!;
        })
        .addCase(getFdpClients.pending, (state) => {
          state.isRtsLoading = true;
        })
        .addCase(getFdpClients.fulfilled, (state, action) => {
          state.isRtsLoading = false;
          if (action.payload.isSuccess) {
            state.fdpAssociatedClients = action.payload.data;
          } else {
            state.fdpAssociatedClients = [];
          }
        })
        .addCase(getFdpClients.rejected, (state, action) => {
          state.isRtsLoading = false;
          state.errorMessage = action.error.message!;
        })
    }
  });
  

  export default dedicatedDeliveryRtsSlice.reducer;